import type { ComponentType } from 'react'
import type { Me, RangeParams } from '../api/types'
import type { Route } from './router'

export interface RoutedViewProps {
  readonly range: RangeParams
  readonly me: Me
  readonly refreshTick: number
}

type RouteName = Route['view']
type RouteModule = { default: ComponentType<RoutedViewProps> }
type RouteLoader = () => Promise<RouteModule>

/**
 * Keep the authenticated shell small and stable while each substantial view
 * loads on demand. Authentication and authorization remain server-side; these
 * loaders are only a delivery optimization.
 */
export const ROUTE_VIEW_LOADERS = {
  dashboard: async () => ({ default: (await import('../views/dashboard/DashboardView')).DashboardView }),
  models: async () => ({ default: (await import('../views/models/ModelsView')).ModelsView }),
  tools: async () => ({ default: (await import('../views/tools/ToolsView')).ToolsView }),
  hours: async () => ({ default: (await import('../views/hours/HoursView')).HoursView }),
  sessions: async () => ({ default: (await import('../views/sessions/SessionsView')).SessionsView }),
  projects: async () => ({ default: (await import('../views/projects/ProjectsView')).ProjectsView }),
  quotas: async () => ({ default: (await import('../views/quotas/QuotasView')).QuotasView }),
  people: async () => ({ default: (await import('../views/people/PeopleView')).PeopleView }),
  events: async () => ({ default: (await import('../views/events/EventsView')).EventsView }),
  reconciliation: async () => ({
    default: (await import('../views/reconciliation/ReconciliationView')).ReconciliationView,
  }),
  account: async () => ({ default: (await import('../views/account/AccountView')).AccountView }),
  sources: async () => ({ default: (await import('../views/sources/SourcesView')).SourcesView }),
  'data-quality': async () => ({
    default: (await import('../views/data-quality/DataQualityView')).DataQualityView,
  }),
  budgets: async () => ({ default: (await import('../views/budgets/BudgetsView')).BudgetsView }),
} satisfies Record<RouteName, RouteLoader>

